import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=df71c6ea&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df71c6ea')) {
      api.createRecord('df71c6ea', component.options)
    } else {
      api.reload('df71c6ea', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=df71c6ea&", function () {
      api.rerender('df71c6ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-209pZ5VOBQdYH/JS/comp/FavElement.vue"
export default component.exports